export default __webpack_public_path__ + "static/media/logincomercio.195fb68f.svg";